
webpack.register(
    'components/svg-image/svg-image',
    function() {
        return require('components/svg-image/svg-image');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/svg-image/svg-image\" />\r\n\r\n<a class=\"c-modal-description-icon\" ($click)=\"open(%event, %element)\" type=\"button\">\r\n    <span class=\"s-modal-description__icon\">\r\n        <svg-image image=\"sprites.svg#icon-tooltip\"></svg-image>\r\n    </span>\r\n</a>\r\n");